import React, { useState } from 'react'
import { SelectPicker } from 'rsuite'
import { blockTypes } from './EditorItem'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'

type BannerBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function NewBlock ({
  block,
  onChange
}: BannerBlockProps) {

  const selectData = blockTypes.filter(bt => bt.type).map((blockType) => ({
    label: blockType.name,
    value: blockType.type
  }))


  return (
    <div>
      <h4>Выберите тип блока</h4>
      <SelectPicker
        data={selectData}
        value={block.type}
        onSelect={(value) => {
          if (onChange && value) {
            onChange({
              ...block,
              type: value,
            })
          }
        }}
        placeholder="Выберите тип блока"
      />
    </div>
  )
}